import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

export class ImportLanesAPI {
    constructor() {
        this.baseUrl = new URL("import/lane/", apiDataManagerBaseURL);
    }

    uploadFile(file) {
        return API.authenticatedRequest({
            url: this.baseUrl,
            method: HTTPMethod.POST,
            contentType: ContentType.MULTIPART,
            token: authenticationCentral.accessToken,
            body: file
        });
    }
}